module.exports = __webpack_public_path__ + "img/logo.3aed1a52.png";